import React, { memo } from 'react';
import styled from 'styled-components';

import { Heading, CloseButton } from 'atoms';

interface IPopupContainerStyle {
  width?: string;
  /**
   * 32px bottom padding instead of the legacy 72px. Card popups end in their own footer row — under it the
   * legacy padding read as ~80px of empty white (проверка глазами 0101).
   */
  dense?: boolean;
}

export interface IPopupContainer extends IPopupContainerStyle {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const PopupContainer = memo(
  ({ title, onClose, children, width, dense }: IPopupContainer) => (
    <Wrapper width={width} dense={dense}>
      <InnerWrapper dense={dense}>
        {title && <Heading>{title}</Heading>}
        <CloseButtonStyled onClick={onClose} />
        {children}
      </InnerWrapper>
    </Wrapper>
  ),
);

const Wrapper = styled.div<IPopupContainerStyle>`
  width: ${({ width }) => width || '864px'};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: ${({ dense }) => (dense ? '48px 64px 32px' : '48px 64px 72px 64px')};
  border: none;
  background-color: var(--k-bg-ffffff);
`;

const InnerWrapper = styled.div<IPopupContainerStyle>`
  position: relative;

  /* The close button («Закрыть ✕» / «Zamknij ✕», ~93px) is absolutely
     positioned over the title row: a long title ran under it (PL «Wystaw VAT
     z proformy P1/05/2026»). Dense popups reserve its width. */
  ${({ dense }) =>
    dense
      ? `
  & > h4:first-child {
    box-sizing: border-box;
    padding-right: 112px;
  }`
      : ''}
`;

const CloseButtonStyled = styled(CloseButton)`
  position: absolute;
  top: 0;
  right: 0;
`;
